/**
 * ARKit blendshape names in the exact order the server sends them (indices 0-51).
 * Source: AvatarosWhisper/Private/AnimationFrameLiveLinkSource.cpp
 *
 * Lives in its own module (rather than inside AudioAnimationBuffer) so pure-logic
 * consumers — rigControlState, unit tests — can read the canonical channel order
 * without pulling in the network/perf-probe stack. AudioAnimationBuffer re-exports
 * it, so every existing `import { ARKIT_NAMES } from '.../AudioAnimationBuffer'`
 * keeps working and there is still exactly one copy of the list.
 */
export const ARKIT_NAMES = [
  'EyeBlinkLeft', 'EyeLookDownLeft', 'EyeLookInLeft', 'EyeLookOutLeft',
  'EyeLookUpLeft', 'EyeSquintLeft', 'EyeWideLeft',
  'EyeBlinkRight', 'EyeLookDownRight', 'EyeLookInRight', 'EyeLookOutRight',
  'EyeLookUpRight', 'EyeSquintRight', 'EyeWideRight',
  'JawForward', 'JawLeft', 'JawRight', 'JawOpen',
  'MouthClose', 'MouthFunnel', 'MouthPucker', 'MouthLeft', 'MouthRight',
  'MouthSmileLeft', 'MouthSmileRight', 'MouthFrownLeft', 'MouthFrownRight',
  'MouthDimpleLeft', 'MouthDimpleRight', 'MouthStretchLeft', 'MouthStretchRight',
  'MouthRollLower', 'MouthRollUpper', 'MouthShrugLower', 'MouthShrugUpper',
  'MouthPressLeft', 'MouthPressRight', 'MouthLowerDownLeft', 'MouthLowerDownRight',
  'MouthUpperUpLeft', 'MouthUpperUpRight',
  'BrowDownLeft', 'BrowDownRight', 'BrowInnerUp', 'BrowOuterUpLeft', 'BrowOuterUpRight',
  'CheekPuff', 'CheekSquintLeft', 'CheekSquintRight',
  'NoseSneerLeft', 'NoseSneerRight',
  'TongueOut',
]
